import mixpanel from 'mixpanel-browser'
import * as moment from 'moment'
import Cookies from 'universal-cookie'

import SecurityService from '../services/SecurityService'
const securitySvc = SecurityService.singletonInstance()

const cookies = new Cookies()

const initMixpanel = async () => {
  try {
    const decrypted = await securitySvc.retrieveSensitiveData('92469f8a-4e32-4ca6-9df2-20774c98286c')

    mixpanel.init(decrypted, {
      track_pageview: false,
      debug: process.env.NODE_ENV === 'development',
      persistence: 'localStorage'
    })
  } catch (err) {
    console.log(err)
  }
}

const mixpanelAliasUser = user => {
  try {
    if (user) {
      mixpanel.alias(user._id)
    }
  } catch (err) {
    console.log(err)
  }
}
const mixpanelIdentifyUser = (user, inTeams) => {
  const region = cookies.get('x-region-admin')

  try {
    if (user) {
      mixpanel.identify(user._id)
      mixpanel.register({
        role: user.role,
        subscriptionStatus: user.tenant.subscriptionStatus,
        dayFromSignupDate: moment().diff(moment(user.createdAt), 'days'),
        platform: inTeams ? 'teams' : 'web',
        environment: 'live',
        'Tenant Graph Size': user.tenant.graphTotalUserCount,
        'Tenant Name': user.tenant.displayName,
        goalsActive: !user.tenant.settings.goalDisabled,
        reviewsActive: !user.tenant.settings.reviewDisabled,
        surveysActive: !user.tenant.settings.surveyDisabled,
        recognitionsActive: !user.tenant.settings.recognitionDisabled,
        feedbacksActive: !user.tenant.settings.feedbackDisabled,
        tasksActive: !user.tenant.settings.taskDisabled,
        meetingsActive: !user.tenant.settings.meetingDisabled,
        region: region
      })
    }
  } catch (err) {
    console.log(err)
  }
}

const mixpanelSwitchToDemoEnvironment = () => {
  try {
    mixpanel.register({
      environment: 'demo'
    })
  } catch (err) {
    console.log(err)
  }
}

const mixpanelSwitchToLiveEnvironment = () => {
  try {
    mixpanel.register({
      environment: 'live'
    })
  } catch (err) {
    console.log(err)
  }
}

const mixpanelPageViewEvent = (page, properties?) => {
  mixpanel.track_pageview({ page: page, ...properties })
}

const mixpanelMenuClickedEvent = (buttonName, properties?) => {
  try {
    const urlName = window.location.href.split('#').pop()
    mixpanel.track('Menu Clicked', {
      buttonName: buttonName,
      openedFrom: 'Navbar',
      pageUrl: urlName,
      ...properties
    })
  } catch (err) {
    console.log(err)
  }
}

const mixpanelButtonClickedEvent = (buttonName, openedFrom, properties?) => {
  try {
    const urlName = window.location.href.split('#').pop()
    mixpanel.track('Button Clicked', {
      buttonName: buttonName,
      openedFrom: openedFrom,
      pageUrl: urlName,
      ...properties
    })
  } catch (err) {
    console.log(err)
  }
}

const mixpanelTabClickedEvent = (buttonName, openedFrom, properties?) => {
  try {
    const urlName = window.location.href.split('#').pop()
    mixpanel.track('Tab Clicked', {
      buttonName: buttonName,
      openedFrom: openedFrom,
      pageUrl: urlName,
      ...properties
    })
  } catch (err) {
    console.log(err)
  }
}

const mixpanelSubmitClickedEvent = (buttonName, openedFrom, properties?) => {
  try {
    const urlName = window.location.href.split('#').pop()
    mixpanel.track('Submit Clicked', {
      buttonName: buttonName,
      openedFrom: openedFrom,
      pageUrl: urlName,
      ...properties
    })
  } catch (err) {
    console.log(err)
  }
}

const mixpanelOpenClickedEvent = (buttonName, openedFrom, properties?) => {
  try {
    const urlName = window.location.href.split('#').pop()
    mixpanel.track('Open Clicked', {
      buttonName: buttonName,
      openedFrom: openedFrom,
      pageUrl: urlName,
      ...properties
    })
  } catch (err) {
    console.log(err)
  }
}

const mixpanelLoginEvent = () => {
  try {
    mixpanel.track('Login')
  } catch (err) {
    console.log(err)
  }
}

const mixpanelLogoutEvent = () => {
  try {
    mixpanel.track('Logout')
    resetMixpanel()
  } catch (err) {
    console.log(err)
  }
}

const resetMixpanel = () => {
  mixpanel.reset()
}

const mixpanelCustomEvent = (eventName, properties = {}) => {
  try {
    mixpanel.track(eventName, {
      ...properties
    })
  } catch (err) {
    console.log(err)
  }
}

export {
  initMixpanel,
  mixpanelMenuClickedEvent,
  resetMixpanel,
  mixpanelButtonClickedEvent,
  mixpanelTabClickedEvent,
  mixpanelSubmitClickedEvent,
  mixpanelOpenClickedEvent,
  mixpanelAliasUser,
  mixpanelIdentifyUser,
  mixpanelLoginEvent,
  mixpanelLogoutEvent,
  mixpanelPageViewEvent,
  mixpanelSwitchToDemoEnvironment,
  mixpanelSwitchToLiveEnvironment,
  mixpanelCustomEvent
}
